// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yI9zA","type":"styles_type__2481C","choices":"styles_choices__2heK3"};